<template>
    <div class="lineReport">
        <div class="myChart" :id="lineDatas.id" style="width:100%;height:300px"></div>
    </div>
</template>

<script>
import echarts from 'echarts'
export default {
    name: 'lineReportStar',
    props: ['lineDatas'],
    data() {
        return {}
    },
    mounted() {
        // console.log('lineDatas',this.lineDatas)
        // console.log('lineDatas data',this.lineDatas.data)
        // console.log('lineDatas legend',this.lineDatas.legend)
        this.drawLine()
    },
    methods: {
        drawLine() {
            var myChart = echarts.init(document.getElementById(this.lineDatas.id))
            let [seriesList, colorList] = [[], []]
            for (let i = 0; i < this.lineDatas.data.length; i++) {
                colorList.push(this.lineDatas.data[i].color)
                seriesList.push({
                    smooth: true,
                    symbolSize: 2,
                    name: this.lineDatas.data[i].title,
                    type: 'line',
                    data: this.lineDatas.data[i].list,
                    itemStyle: {
                        normal: {
                            lineStyle: {
                                width: 2, // 折线宽度
                                color: this.lineDatas.data[i].color // 折线颜色
                            }
                        }
                    }
                })
            }
            var option = {
                color: colorList,
                title: {
                    text: this.lineDatas.title,
                    subtext: this.lineDatas.subText,
                    left: 'left',
                    textStyle: {
                        fontSize: 16
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    // formatter: '{a} <br/>{b} : {c}'
                },
                legend: this.lineDatas.legend,
                // {
                //     left: 'center',
                //     data: ['访问人数', '新用户']
                // },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    },
                    data: this.lineDatas.xdata
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                yAxis: [
                    {
                        type: 'value',
                        name: '',
                        nameTextStyle: {
                            color: '#333'
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#ccc'
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: ['#f2f2f2']
                            }
                        }
                    }
                ],
                series: seriesList
            }

            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option)
        }
    },
    watch: {
        lineDatas: {
            handler: function() {
                this.drawLine()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
.myChart{
}
</style>
